// src/pages/NotVerifiedPage.js
import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import PageWrapper from "../pageWrapper";

// CSS
import "./VerificationPage.css";

// Components
import PageLoader from "Components/Other Components/pageLoader";
import Button from "../../Components/Other Components/button";
import Title from "../../Components/Other Components/Title";

// Functions and hooks
import { ResendRegisterEmail } from "../../BackendAccess/UserHooks";
import { fetchWithTimeout } from "../../hooks/useFetchWithTimeout";
import { useErrorHandler } from "../../hooks/errorHandler";
import { useNotification } from "../../Contexts/NotificationContext";

export default function NotVerifiedPage() {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [pageError, setPageError] = useState(null);

  let sentFirst = false;
  const PAGETYPES = ["Verification", "NotVerified", "Verified"];

  const navigate = useNavigate();
  const location = useLocation();
  const { PageType, email } = location.state || {};

  const { showNotification } = useNotification();
  useErrorHandler(error, showNotification, setPageError);

  useEffect(() => {
    if (!PAGETYPES.includes(PageType) || !email) {
      navigate("/notFound");
    } else if (!sentFirst) {
      sentFirst = true;
      onResendClick();
    }
  }, [PageType]);

  const onResendClick = async () => {
    try {
      showNotification(t("notVerified.info.sending"), "info");
      const [data, err] = await fetchWithTimeout(() =>
        ResendRegisterEmail(email)
      );
      if (err) {
        setError(err);
      } else {
        showNotification(t("notVerified.success.sent"), "success");
      }
    } catch {
      setError({ err: t("notVerified.error.server"), errCode: 500 });
    }
  };

  const onLoginClick = () => navigate("/login");

  return (
    <PageWrapper>
      <PageLoader loading={loading} error={pageError}>
        <div className="page-content">
          <div className="container-bordered verification-container mt-3">
            <Title>{t("notVerified.title")}</Title>
            <span className="verification-text">
              {t("notVerified.message.sentTo", { email })}
            </span>
            <span className="verification-text font-bold">
              {t("notVerified.message.checkEmail")}
            </span>
            <span className="verification-text">
              {t("notVerified.message.notFound")}
            </span>
            <div className="btn-container mt-3 w-100">
              <Button onClick={onResendClick}>
                {t("notVerified.button.resend")}
              </Button>
              <Button onClick={onLoginClick}>
                {t("notVerified.button.login")}
              </Button>
            </div>
          </div>
        </div>
      </PageLoader>
    </PageWrapper>
  );
}
